// Module
var code = "<div>\n    <div class=\"loginPageMessagesContent\" style=\"text-align: center; color: white;\">\n        <div id=\"connectContent\" class=\"pageMessage\">\n            <h2 id=\"starttitle\">&nbsp;</h2>\n        </div>\n    </div>\n</div>";
// Exports
module.exports = code;